import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
      navbar: '#F0F0F0',
    },
    text: { primary: '#333333', secondary: '#666666' },
    brand: { main: '#F3BA2F' },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#1A1C22',
      paper: '#2A2E37',
      navbar: '#1A1C22',
    },
    text: { primary: '#E0E0E0', secondary: '#B0B0B0' },
    brand: { main: '#F3BA2F' },
  },
});